module.exports = __webpack_public_path__ + "img/pen-to-square.cfaf8476.svg";